import api from './axios';
import { authHeader } from '../helpers';
import { authService } from './authentication.service';

export const asisService = {
    getAllAsis,
    createAsis,
    removeAsis,
    editAsis,
    getProfilsSaisie,
    getSuggestions,
    createOrUpdateSuggestion,
    deleteSuggestion,
    getElementsForProfil,
    getSynthese,
    getAnneesDisponiblesSynthese,
    createConfiguration,
    downloadAsis
};

async function getAllAsis() {
    return api.get('/Asis/', {
        headers: authHeader()
    })
        .then(authService.handleResponse);
}

async function createAsis(asis) {
    return api.post('/Asis/', asis, {
        headers: authHeader()
    })
        .then(authService.handleResponse);
}

async function getSynthese(utam, year, period) {
    return api.get(`/Asis/synthese/${utam}/${year}/${period}`, {
        headers: authHeader()
    })
        .then(authService.handleResponse);
}

async function getAnneesDisponiblesSynthese(utam) {
    return api.get(`/Asis/synthese/annees/${utam}`, {
        headers: authHeader()
    })
        .then(authService.handleResponse);
}

async function editAsis(id, newDescription, newLibelle, newFileName) {
    if (!newFileName.match(/\.xlsm$/gi)) {
        newFileName = newFileName + '.xlsm';
    }

    return api.patch(`/Asis/${id}`, { libelle: newLibelle, description: newDescription, nomFichier: newFileName }, {
        headers: authHeader()
    })
        .then(authService.handleResponse);
}

async function createConfiguration(idAsis, config) {
    return api.patch(`/Asis/${idAsis}/pointsCollecte`, config, {
        headers: authHeader()
    })
        .then(authService.handleResponse);
}

async function removeAsis(id) {
    return api.delete(`/Asis/${id}`, {
        headers: authHeader()
    })
        .then(authService.handleResponse);
}

async function getProfilsSaisie(utam) {
    return api.get('/Asis/profilsSaisie', {
        headers: authHeader()
    })
        .then(authService.handleResponse)
        .then(data => {
            if (utam) {
                return data.filter(x => x.utam === utam || x.utam === 'DPSM');
            }
            return data;
        });
}

async function getSuggestions(utam) {
    return api.get('/Asis/suggestions', {
        headers: authHeader()
    })
        .then(authService.handleResponse)
        .then(data => {
            if (utam) {
                return data.filter(x => x.utam === utam || x.utam === 'DPSM');
            }
            return data;
        });
}

async function createOrUpdateSuggestion(suggestion) {
    const method = suggestion.id === 0 ? api.post : api.patch;
    return method('/Asis/suggestions', suggestion, {
        headers: authHeader()
    })
        .then(authService.handleResponse);
}

async function deleteSuggestion(id) {
    return api.delete(`/Asis/suggestions/${id}`, {
        headers: authHeader()
    })
        .then(authService.handleResponse);
}

async function getElementsForProfil(profileId, survId) {
    return api.get(`/Asis/profilSaisie/${profileId}/Surveillance/${survId}/ElementsPatrimoine`, {
        headers: authHeader()
    })
        .then(authService.handleResponse);
}

async function downloadAsis(id, dateDebut, dateFin) {
    return api.get(`/Asis/download/${id}?dateDebut=${dateDebut}&dateFin=${dateFin}`, {
        headers: authHeader(),
        responseType: 'blob' // Required for handling file downloads
    })
        .then(response => {
            const contentDisposition = response.headers['content-disposition'];
            const fileName = contentDisposition.match(/filename=(.+);/i)[1];

            const blob = response.data;
            const a = document.createElement('a');
            a.style.display = 'none';

            if (window.navigator.msSaveOrOpenBlob) {
                a.onclick = () => {
                    window.navigator.msSaveOrOpenBlob(blob, fileName);
                };
            } else {
                const url = window.URL.createObjectURL(blob);
                a.href = url;
                a.download = fileName;
                document.body.appendChild(a);
                a.click();
                window.URL.revokeObjectURL(url);
            }

            document.body.appendChild(a);
            a.click();
            a.remove();

            return response.data;
        })
        .catch(error => {
            if (error.response && error.response.data) {
                return Promise.reject(error.response.data);
            }
            return Promise.reject(error);
        });
}
